module.exports = __webpack_public_path__ + "img/symbol_12.a4b1f1d7.png";